import { render, staticRenderFns } from "./LineSeparator.vue?vue&type=template&id=af535a3a&scoped=true"
import script from "./LineSeparator.vue?vue&type=script&lang=js"
export * from "./LineSeparator.vue?vue&type=script&lang=js"
import style0 from "./LineSeparator.vue?vue&type=style&index=0&id=af535a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af535a3a",
  null
  
)

export default component.exports